import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  root: {
    borderColor: "rgb(209,219,227)",
    borderWidth: "2px",
    padding: "3em 1em",
    "& .more-link": {
      display: "inline",
      marginLeft: 5,
      color: theme.palette.primary.main,
    },
    "& .more-link:hover": {
      textDecoration: "underline",
    },
    "& .screen-reader-text": {
      display: "none",
    },
  },
  title: {
    padding: "0.75em 0 1em 0",
  },
  details: {
    width: "85%",
  },
}));

export default function BlogCard({ data: { id, date, title, excerpt } }) {
  const classes = useStyles();
  const changeDate = (date) => {
    const change = new Date(date);
    return change.toDateString();
  };
  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography color="secondary" variant="caption">
          {changeDate(date)}
        </Typography>
        <Link href={`/blogs/${id}`}>
          <Typography
            className={classes.title}
            variant="h6"
            component="h2"
            color="primary"
          >
            {title.rendered}
          </Typography>
        </Link>
        <Typography
          className={classes.details}
          variant="body2"
          component="p"
          color="secondary"
          dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
        ></Typography>
      </CardContent>
    </Card>
  );
}
